// removed by extract-text-webpack-plugin
module.exports = {"widget-form":"src-modules-settings-WidgetsSettingsView-__WidgetsSettingsView__widget-form--3BgDf","widget-code":"src-modules-settings-WidgetsSettingsView-__WidgetsSettingsView__widget-code--uyaG_","widget-overview":"src-modules-settings-WidgetsSettingsView-__WidgetsSettingsView__widget-overview--2A3VI"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/settings/WidgetsSettingsView/WidgetsSettingsView.less
// module id = 373
// module chunks = 0